import { Controller } from '@hotwired/stimulus';
import { isMobile } from '../helpers';

export default class extends Controller {

    classesToRestore = {};

    connect() {
        if (this.element.nodeName === 'SELECT') {
            this.element.addEventListener('change', () => {
                this.toggleSelect();
            });
            this.toggleSelect();
        } else if (this.element.nodeName === 'INPUT' && this.element.type.toLowerCase() === 'checkbox') {
            this.element.addEventListener('change', () => {
                this.toggleCheckBox();
            });
            this.toggleCheckBox();
        } else {
            this.element.querySelectorAll(`[data-toggler]`).forEach((toggler) => {
                toggler.addEventListener('click', () => {
                    this.toggleElement(toggler);
                });
            })
        }
    }

    toggleElement(toggler) {
        const name = toggler.getAttribute('data-toggler');
        let toggleOff = toggler.getAttribute('data-toggle-off');
        let toggleOn = toggler.getAttribute('data-toggle-on');

        if (isMobile()) {
            if (name.includes('products-modal')) {
                this.scrollToElementWithOffset(40);
            }
        }

        if (toggler.hasAttribute('data-alt-text')) {
            const text = toggler.innerHTML;
            toggler.innerHTML = toggler.getAttribute('data-alt-text');
            toggler.setAttribute('data-alt-text', text);
        }

        toggler.classList.toggle('toggled');
        document.querySelectorAll(`[data-toggler=${name}]`).forEach((item) => {
            if (item.getAttribute('data-toggle-on') !== toggleOn) {
                item.classList.remove('toggled');
            }
        });

        if (!toggleOff && !toggleOn) {
            Array.from(document.querySelectorAll('[data-toggle]'))
                .filter(el => el.getAttribute('data-toggle')
                    .includes(name)).forEach((elm) => {

                const display = elm.currentStyle ? elm.currentStyle.display : getComputedStyle(elm, null).display;
                if (display === 'none') {
                    elm.classList.remove('!hidden');
                    elm.classList.forEach(className => {
                        if (className.includes("hidden")) {
                            elm.classList.remove(className);
                            if (!this.classesToRestore[elm]) {
                                this.classesToRestore[elm] = [];
                            }
                            this.classesToRestore[elm].push(className);
                        }
                    });
                } else {
                    elm.classList.add('!hidden');
                    elm.classList.add('hidden');
                    if (this.classesToRestore[elm]) {
                        this.classesToRestore[elm].forEach(className => {
                            elm.classList.add(className);
                        });
                        this.classesToRestore[elm] = [];
                    }
                }
            });
        }

        if (toggleOff) {
            toggleOff = toggleOff.split(' ');
            toggleOff.forEach((name) => {
                document.querySelectorAll('[data-toggle]').forEach((elm) => {
                    const attr = elm.getAttribute('data-toggle').split(' ');
                    if (attr.some(item => name === item)) {
                        elm.classList.add('hidden');
                        elm.classList.add('!hidden');
                        if (this.classesToRestore[elm]) {
                            this.classesToRestore[elm].forEach(className => {
                                elm.classList.add(className);
                            });
                            this.classesToRestore[elm] = [];
                        }
                    }
                });
            });
        }

        if (toggleOn) {
            toggleOn = toggleOn.split(' ');
            toggleOn.forEach((name) => {
                document.querySelectorAll('[data-toggle]').forEach((elm) => {
                    const attr = elm.getAttribute('data-toggle').split(' ');
                    if (attr.some(item => name === item)) {
                        elm.classList.remove('!hidden');
                        elm.classList.forEach(className => {
                            if (className.includes("hidden")) {
                                elm.classList.remove(className);
                                if (!this.classesToRestore[elm]) {
                                    this.classesToRestore[elm] = [];
                                }
                                this.classesToRestore[elm].push(className);
                            }
                        });
                    }
                });
            });
        }
    }

    toggleCheckBox() {
        const checked = this.element.checked;
        const name = this.element.name;
        if (checked) {
            document.querySelectorAll(`[data-toggle=${name}]`).forEach(function(opt) {
                opt.classList.remove('hidden');
            });
        } else {
            document.querySelectorAll(`[data-toggle=${name}]`).forEach(function(opt) {
                opt.classList.add('hidden');
            });
        }
    }

    toggleSelect() {
        const options = this.element.options;
        for (const option of options) {
            if (option.value && option.hasAttribute('value')) {
                document.querySelectorAll(`.${option.value}`).forEach(function(opt) {
                    opt.classList.add('hidden');
                });
            }
        }

        const option = options[this.element.selectedIndex];
        if (option.value && option.hasAttribute('value')) {
            document.querySelectorAll(`.${option.value}`).forEach(function(opt) {
                opt.classList.remove('hidden');
            });
        }
    }

    scrollToElementWithOffset(offset) {
        const modal = this.element.closest('.modal-scroll-container');
        if (modal) {
            setTimeout(() => {
                modal.scrollTo({
                    top: offset,
                    behavior: 'smooth'
                });
            }, 1);
        }
    }
}